import {tag2url} from '@yandex-delivery/utils'
import {i18n} from 'src/shared/config'

import {
  footerApp as kazFooterApp,
  footerLinks as kazFooterLinks,
  footerLogo as kazFooterLogo,
  legalLinks as kazLegalLinks,
  navLinks as kazNavLinks,
} from './kaz'
import {
  footerApp as rusFooterApp,
  footerLogo as rusFooterLogo,
  legalLinks as rusLegalLinks,
  navLinks as rusNavLinks,
} from './rus'

export const legalLinks = {
  ru: rusLegalLinks,
  kz: kazLegalLinks,
}

export const footerApp = {
  ru: rusFooterApp,
  kz: kazFooterApp,
}

export const footerLogo = {
  ru: rusFooterLogo,
  kz: kazFooterLogo,
}

export const disclaimers = {
  appStore: i18n(
    'order.footer.disclaimer.app-store',
    'App Store является знаком обслуживания компании Apple Inc.',
  ),
  googlePlay: i18n(
    'order.footer.disclaimer.google-play',
    'Google Play и логотип Google Play являются товарными знаками корпорации Google LLC.',
  ),
  appGallery: i18n(
    'order.footer.disclaimer.app-gallery',
    'App Gallery, HUAWEI и логотип HUAWEI являются товарными знаками компании Huawei Technologies Co., Ltd.',
  ),
}

export const navLinks = {
  ru: rusNavLinks,
  kz: kazNavLinks,
}

export const footerLinks = {
  ru: [],
  kz: kazFooterLinks,
}

export const storeButtonTags: {
  [x: string]: {appStore: string; googlePlay: string; appGallery: string}
} = {
  ru: {
    appStore: tag2url('delivery_app_store_button_ru'),
    googlePlay: tag2url('delivery_google_play_button_ru'),
    appGallery: tag2url('delivery_app_gallery_button_ru'),
  },
  kk: {
    appStore: tag2url('delivery_app_store_button_kk'),
    googlePlay: tag2url('delivery_google_play_button_kk'),
    appGallery: tag2url('delivery_app_gallery_button_kk'),
  },
}
